<div
  class="d-flex flex-column"
  style="height: 100vh !important;"
>
  <app-mobile-sidenav
    [class.d-none]="!isMobileMenuOpen"
    (onMobileSidenavToggle)="isMobileMenuOpen = !isMobileMenuOpen"
  >
  </app-mobile-sidenav>
  <app-header (onMobileSidenavToggle)="isMobileMenuOpen = true">
  </app-header>
  <div class="flex-fill overflow-hidden position-relative">
    <router-outlet></router-outlet>
  </div>
</div>
